import type { CircularProgressProps } from '@mui/material'
import { CircularProgress as CircularProgressMui } from '@mui/material'

/**
 * @deprecated Use LoadingIndicator component from pace-web instead.
 */
export const CircularProgress = ({ ...other }: CircularProgressProps) => (
  <CircularProgressMui {...other} />
)
